import { INLINEIMAGE_ATTRIBUTE_ORIGINALSRC } from 'owa-inline-image-consts';
import { ATTRIBUTE_IMAGEPROXYENDPOINT } from './Constants';
import safeGetAttribute from './safeGetAttribute';

export default function isProxyImage(element: HTMLElement): boolean {
    const originalSrc = safeGetAttribute(element, INLINEIMAGE_ATTRIBUTE_ORIGINALSRC);
    const proxyEndPoint = safeGetAttribute(element, ATTRIBUTE_IMAGEPROXYENDPOINT);

    // When an img carries originalSrc and data-imageproxyendpoint,
    // it is considered proxy capable
    return !!originalSrc && !!proxyEndPoint;
}
